import { useCallback, useEffect, useState } from "react"
import {
  fetchDocumentSettings,
  generateQuotation,
  updateDocumentSettings,
} from "../api/documentSettingsApi"

function normalizeErrors(err) {
  return err.response?.data?.errors || [err.response?.data?.error || err.message || "Something went wrong"]
}

// Loads the org document config and exposes a save mutation. Keeps a local
// working copy so the live preview updates instantly while editing.
export function useDocumentSettings() {
  const [config, setConfig] = useState(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    let active = true
    fetchDocumentSettings()
      .then((cfg) => active && setConfig(cfg))
      .catch((err) => active && setError(normalizeErrors(err)))
      .finally(() => active && setLoading(false))
    return () => {
      active = false
    }
  }, [])

  const save = useCallback(async (next) => {
    setSaving(true)
    try {
      const saved = await updateDocumentSettings(next)
      setConfig(saved)
      return saved
    } catch (err) {
      throw normalizeErrors(err)
    } finally {
      setSaving(false)
    }
  }, [])

  return { config, setConfig, loading, saving, error, save }
}

export function useGenerateQuotation() {
  const [isPending, setPending] = useState(false)
  const mutate = useCallback(async (payload) => {
    setPending(true)
    try {
      return await generateQuotation(payload)
    } catch (err) {
      throw normalizeErrors(err)
    } finally {
      setPending(false)
    }
  }, [])
  return { mutate, isPending }
}
